import { useMemo } from "react";
import { useSelector } from "react-redux";

const useToggle = () => {
  const toggle = useSelector((state) => state?.auth?.toggle);
  return useMemo(() => toggle, [toggle]);
};

export default useToggle;
